import Lottie from 'lottie-react';
import { FC } from 'react';
import LoadingAnimation from './data';

const PaperPlaneLoader: FC<{ className?: string }> = ({ className }) => (
  <div className={className}>
    <Lottie animationData={LoadingAnimation} loop />
  </div>
);

export default PaperPlaneLoader;
